import {
  fetchBalance,
  getSapToken,
  loginSuccess,
  logoutSuccess,
  RootState,
  setLoading,
  showToast,
  useAppDispatch,
  useAppSelector,
} from "@hypexone/uicore";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SVLS_API_CLIENT } from "../../App.utils";

const useOtpLogin = (modalCloseHandler: Function, redirectUrl?: string) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const loggedIn = useAppSelector((state: RootState) => state.auth.loggedIn);
  const [shouldFetchBalance, setShouldFetchBalance] = useState(false);

  useEffect(() => {
    otpLogin();
  }, []);

  const otpLogin = async () => {
    if (redirectUrl) {
      const urlParams = new URLSearchParams(window.location.search);
      try {
        if (loggedIn) {
          sessionStorage.clear();
          dispatch(logoutSuccess());
        }
        dispatch(setLoading(true));

        const response = await SVLS_API_CLIENT.post("account/v2/otp-login", {
          otp: urlParams.get("otp"),
        });

        if (response.data != null) {
          sessionStorage.setItem("jwt_token", response.data);
        } else {
          dispatch(
            showToast({
              type: "error",
              message:
                response.data?.message ||
                "Login Failed. Please come back again.",
            })
          );
          navigate("/login-failed");
          return;
        }

        const claim = response.data.split(".")[1];
        const userName = JSON.parse(window.atob(claim)).owner;
        sessionStorage.setItem("username", userName);
        localStorage.removeItem(`multiMarket_${userName?.toLowerCase()}`);
        sessionStorage.setItem("aid", JSON.parse(window.atob(claim)).aid);
        sessionStorage.setItem(
          "displayName",
          JSON.parse(window.atob(claim)).dispName
        );
        const params = new URLSearchParams(window.location.search);
        const url = params.get("logoUrl");
        if (url) {
          const cleanUrl = decodeURIComponent(url).trim().replace(/^"|"$/g, "");
          sessionStorage.setItem("brandLogo", cleanUrl);
        }
        dispatch(setLoading(false));
        setShouldFetchBalance(true);
        dispatch(loginSuccess(response.data));
        navigate("/home");
        dispatch(getSapToken(response.data));
      } catch (err) {
        dispatch(
          showToast({
            type: "error",
            message: "Login Failed. Please come back again.",
          })
        );
        navigate("/login-failed");
      } finally {
        modalCloseHandler();
      }
    }
  };

  useEffect(() => {
    if (shouldFetchBalance) {
      dispatch(fetchBalance());
    }
  }, [shouldFetchBalance]);
};

export default useOtpLogin;
